export default __webpack_public_path__ + "static/media/alien-worlds-icon.5c3d9616.svg";